import React from 'react';
import { Wallet, Percent, Package, Headphones } from 'lucide-react';

const VANTAGENS = [
  { icone: Wallet, titulo: 'Sem mensalidade', texto: 'Você paga só o frete que usar.' },
  { icone: Percent, titulo: 'Frete com desconto', texto: 'PAC e SEDEX abaixo do balcão.' },
  { icone: Package, titulo: 'Tudo num lugar', texto: 'Cálculo, etiqueta, rastreio e carteira.' },
  { icone: Headphones, titulo: 'Atendimento de gente', texto: 'Suporte humanizado quando precisar.' },
];

const Features = () => (
  <section id="beneficios" className="bg-[#F6F8FC] py-[70px] lg:py-[110px] scroll-mt-20">
    <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
      <h2 className="text-center text-[30px] lg:text-[44px] font-black tracking-tight leading-tight text-slate-900">Por que a <span className="inn-text-gradient">In&apos;Nova Envios</span></h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-7 lg:gap-9 mt-12 lg:mt-14">
        {VANTAGENS.map(({ icone: Icone, titulo, texto }, i) => (
          <div key={titulo}>
            <div className={`w-[52px] h-[52px] rounded-2xl flex items-center justify-center mb-3.5 ${i % 2 ? 'bg-[#FFF1E6] text-[#F77820]' : 'bg-[#EAF1FF] text-[#2A5BC7]'}`}><Icone className="w-6 h-6" strokeWidth={2.2} /></div>
            <h3 className="text-[17px] lg:text-[19px] font-black text-slate-900 mb-1.5">{titulo}</h3>
            <p className="text-slate-500 text-[15px] lg:text-[15.5px] leading-relaxed">{texto}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
